import { Directive, ElementRef, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
var LazyDirective = (function () {
    function LazyDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.lazyLoad = new EventEmitter(false);
    }
    Object.defineProperty(LazyDirective.prototype, "lazyImage", {
        // Image source
        set: function (imagePath) {
            this.getImage(imagePath);
        },
        enumerable: true,
        configurable: true
    });
    LazyDirective.prototype.getImage = function (imagePath) {
        var _this = this;
        this.lazyLoad.emit(false);
        var img = this.renderer.createElement('img');
        img.src = imagePath;
        img.onload = function () {
            _this.renderer.setProperty(_this.el.nativeElement, 'src', imagePath);
            _this.lazyLoad.emit(true);
        };
        img.onerror = function (err) {
            console.error('[GalleryLazyDirective]:', err);
            _this.lazyLoad.emit(err);
        };
    };
    return LazyDirective;
}());
export { LazyDirective };
LazyDirective.decorators = [
    { type: Directive, args: [{
                selector: '[lazyImage]'
            },] },
];
/** @nocollapse */
LazyDirective.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
LazyDirective.propDecorators = {
    'lazyImage': [{ type: Input, args: ['lazyImage',] },],
    'lazyLoad': [{ type: Output },],
};
//# sourceMappingURL=lazy.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-gallery/directive/lazy.directive.js
// module id = 233
// module chunks = 0